module.exports = __webpack_public_path__ + "static/img/4254_phase_function_Paper_PointsHejduk_Prediction.11902be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4254_phase_function_Paper_PointsHejduk_Prediction.png
// module id = K6G0
// module chunks = 0